exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete-suggestion.is-active[data-v-d9b64338],.autocomplete-suggestion[data-v-d9b64338]:hover{background-color:#92b2f1;color:#fff}", ""]);

// exports
